module.exports = __webpack_public_path__ + "img/layer-1.034ce5c3.svg";